
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class GeneralMenu extends Vue {
    get skilldUrl() {
        return this.$store.state.root && this.$store.state.root._links.skilld.href;
    }

    get capacityPlanUrl() {
        return this.$store.state.root && this.$store.state.root._links.capacityPlan.href;
    }

    get joeyUrl() {
        return this.$store.state.root && this.$store.state.root._links.joey.href;
    }

    public openFeedbackService() {
      const title = "Feedback AE Tooling";
      window.open(`https://aewiki.atlassian.net/servicedesk/customer/portal/47/group/135/create/581?summary=${title}`, "_blank");
    }
}
